import type { Exercise } from "./schemas/exercise.js";
import type { MovementPattern } from "./schemas/muscle.js";

// Movement-pattern lookup keyed by exercise slug, used to drive the
// post-save MAX-bump check on Edit/Repeat (mobile + web-rnw logger
// hosts). A catalog→pattern projection for the logger handoff, not
// list presentation — kept out of workoutsList.ts on purpose, that
// file is scoped to grouping/label helpers only.
// Missing pattern → null (the MAX-bump path silently skips entries
// with an unknown pattern). The caller wraps the catalog fetch in
// try/catch and passes whatever it got; an empty list yields an
// empty map.
export function buildPatternsBySlug(
  exercises: ReadonlyArray<Exercise>,
): Record<string, MovementPattern | null> {
  const out: Record<string, MovementPattern | null> = {};
  for (const ex of exercises) {
    out[ex.slug] = ex.movementPattern ?? null;
  }
  return out;
}
